import * as React from "react";

function MagnificationIcon({onClick, title, size = 24, className = ""}) {
    return (<div
            className={`Icon MagnificationIcon ${className}`}
            onClick={onClick}
            title={title}
        >
            <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                role="img"
                aria-label={title}
            >
                <circle
                    cx="11"
                    cy="11"
                    r="7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <line
                    x1="16"
                    y1="16"
                    x2="21"
                    y2="21"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>);
}

export default MagnificationIcon;
